import { rest } from 'msw'
export default [
  /**
   * ダイナミックプライシング一覧インプレッション
   */
  rest.get('/imp/pricing_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * ダイナミックプライシング一覧インプレッション
   */
  rest.get('/imp/pricing_read', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * ダイナミックプライシング詳細インプレッション
   */
  rest.get('/imp/pricing_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * ダイナミックプライシング読了インプレッション
   */
  rest.get('/imp/pricing_read', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * ダイナミックプライシング読了完了インプレッション
   */
  rest.get('/imp/pricing_read_complete', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * コンテンツ一覧インプレッション
   */
  rest.get('/imp/content_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * コンテンツ詳細インプレッション
   */
  rest.get('/imp/content_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * コンテンツ読了インプレッション
   */
  rest.get('/imp/content_read', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * コンテンツ読了完了インプレッション
   */
  rest.get('/imp/content_read_complete', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * お知らせ一覧インプレッション
   */
  rest.get('/imp/message_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * お知らせ詳細インプレッション
   */
  rest.get('/imp/message_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),

  /**
   * スタンプシート一覧インプレッション
   */
  rest.get('/imp/stampsheet_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * スタンプシート詳細インプレッション
   */
  rest.get('/imp/stampsheet_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * スタンプシート読了インプレッション
   */
  rest.get('/imp/stampsheet_read', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * スタンプシート読了完了インプレッション
   */
  rest.get('/imp/stampsheet_read_complete', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * チラシ一覧インプレッション
   */
  rest.get('/imp/flyer_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * チラシ詳細インプレッション
   */
  rest.get('/imp/flyer_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * チラシ商品グループ一覧インプレッション
   */
  rest.get('/imp/theme_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * チラシ商品グループ詳細インプレッション
   */
  rest.get('/imp/theme_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * 商品一覧インプレッション
   */
  rest.get('/imp/product_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * 商品詳細インプレッション
   */
  rest.get('/imp/product_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * アンケートインプレッション
   */
  rest.get('/imp/questionnaire_open', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * アクティブインプレッション
   */
  rest.get('/imp/active', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * 広告枠一覧インプレッション
   */
  rest.get('/imp/adv_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * 広告枠詳細インプレッション
   */
  rest.get('/imp/adv_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * 広告枠詳細読了インプレッション
   */
  rest.get('/imp/adv_read', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
  /**
   * 広告枠詳細読了完了インプレッション
   */
  rest.get('/imp/adv_read_complete', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        1: 1,
      })
    )
  }),
]
